export default "__VITE_ASSET__BMw$oG10__"